import { css } from '@emotion/react'
import {
  Card,
  DesignToken,
  Heading,
  SpacingToken,
  Text,
} from '@livechat/design-system-react-components'
import type { CardButtonOptions } from '@livechat/design-system-react-components/dist/components/Card/Card'

import { LocalImage } from '@/components/LocalImage'
import { useImages } from '@/hooks/useImages'

const cardCss = css`
  h4,
  p {
    margin: 0;
  }

  max-width: 320px;
  min-height: 250px;
  background-color: var(${DesignToken.SurfaceSecondaryDefault});
  justify-content: space-between;
  border: none;
  border-radius: 20px;
  padding: var(${SpacingToken.Spacing6});
  text-align: left;
  gap: 0px;

  > div:last-of-type {
    margin-top: var(${SpacingToken.Spacing5});

    > div:first-of-type {
      display: none;
    }
  }
`

const cardHeaderCss = css`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: var(${SpacingToken.Spacing1});
  margin-bottom: var(${SpacingToken.Spacing6});

  > div {
    width: 100%;
    height: 100%;
  }
`

const titleCss = css`
  && {
    margin: var(${SpacingToken.Spacing5}) 0 var(${SpacingToken.Spacing5});
  }
`

interface Props {
  image: string
  title: string
  description: string
  buttonsOptions?: CardButtonOptions[]
  className?: string
}

const WidgetCard = ({
  image,
  title,
  description,
  buttonsOptions = [],
  className,
}: Props) => {
  const images = useImages()
  const widgetPlacementImage = images[image]

  return (
    <Card css={[cardCss, className]} buttonsOptions={buttonsOptions}>
      <div css={cardHeaderCss}>
        <LocalImage image={widgetPlacementImage} alt={`${title} placement`} />
      </div>
      <Heading css={titleCss} size="sm">
        {title}
      </Heading>
      <Text>{description}</Text>
    </Card>
  )
}

export default WidgetCard
